import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { categories } from "@/mocks/site";
import { events } from "@/mocks/events";

export default function CategorySection() {
  const countByCategory = (id: string) => events.filter((item) => item.category === id).length;

  return (
    <section className="w-full bg-background-100" aria-label="主题分类">
      <div className="mx-auto w-full max-w-[1400px] px-4 py-14 md:px-6 md:py-20">
        <SectionHeading
          eyebrow="CATEGORIES"
          title="按主题找线索"
          description="同一条线索往往横跨多个年份。先选一个主题，再顺着时间往下读，很容易看清一件事是怎么一步步走到今天的。"
        />
        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 md:mt-10">
          {categories.map((cat, index) => (
            <Link
              key={cat.id}
              to={`/archive?category=${cat.id}`}
              className="group flex items-start gap-4 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300 md:p-5"
            >
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-primary-100 text-xl text-primary-700 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                <i className={cat.icon} />
              </span>
              <span className="min-w-0 flex-1">
                <span className="flex items-center justify-between gap-2">
                  <span className="font-heading text-base font-bold text-foreground-950">{cat.name}</span>
                  <span className="shrink-0 text-xs text-foreground-400">
                    {String(index + 1).padStart(2, "0")}
                  </span>
                </span>
                <span className="mt-1.5 block text-sm leading-relaxed text-foreground-600">
                  {cat.desc}
                </span>
                <span className="mt-3 flex items-center gap-2 text-xs text-foreground-500">
                  <span className="rounded-full bg-secondary-100 px-2 py-0.5 text-secondary-900">
                    {countByCategory(cat.id)} 篇档案
                  </span>
                  <span className="inline-flex items-center gap-1 font-medium text-primary-600 transition-opacity group-hover:opacity-80">
                    进入分类
                    <i className="ri-arrow-right-line" />
                  </span>
                </span>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}